import { Card, EmptyState, TypeScaleControl } from '../../design'
import { canManageSettings } from '../../session/roles'
import { useReadySession } from '../../session/useSession'
import { NotificationSettings } from '../live/NotificationSettings'
import { PasswordSettings } from '../password/PasswordSettings'
import { AdminSettings } from './AdminSettings'
import { SETTINGS_COPY } from './copy'

export const SettingsPage = () => {
  const { membership } = useReadySession()

  return (
    <div className="settings">
      <h1>{SETTINGS_COPY.title}</h1>

      <Card as="section" className="settings-card">
        <h2>{SETTINGS_COPY.display}</h2>
        <p className="settings-hint measure">{SETTINGS_COPY.displayHint}</p>
        <TypeScaleControl />
      </Card>

      <NotificationSettings />

      <PasswordSettings />

      {canManageSettings(membership.role) ? (
        <AdminSettings />
      ) : (
        <EmptyState title={SETTINGS_COPY.forbidden} description={SETTINGS_COPY.forbiddenBody} />
      )}
    </div>
  )
}
